import { Emitter, Event } from "../../../../../features/event-emitter"
import { ModalId, showErrorStrToast, useUIActions } from "../../../../../features/ui"
import { TableName } from "../../../../../tables"
import { ManualCreditNoteRequest, useAdjustmentNoteLoaders } from "../../../../administration"
import { FiscalDocumentStatus, useFiscalDocumentLoaders } from "../../../../fiscal-documents"
import { useServer } from "../../../../../services/server"
import { useSaleOperationLoaders } from "../../../loaders/saleOperationLoaders"
import { useSaleOperationService } from "../../../services/sale-operation-service/saleOperationService"

export const useActions = () => {
    const saleOperationLoaders = useSaleOperationLoaders()
    const fiscalDocumentLoaders = useFiscalDocumentLoaders()
    const adjustmentNoteLoaders = useAdjustmentNoteLoaders()

    const { createManualCreditNote } = useSaleOperationService()
    const { generateCreditNote } = useServer()

    const { closeModal } = useUIActions()

    const submitCreditNote = async (
        table: TableName,
        operationId: string,
        request: ManualCreditNoteRequest,
        reason: string,
        emitNow = false
    ) => {
        Emitter.emit(Event.DB_SUBMIT, 'Generando nota de crédito...')

        try {
            const notes = await createManualCreditNote(table, operationId, request, reason)

            // La nota ya quedó guardada: si la emisión falla, sigue PENDING para reintentar desde Documentos.
            if (emitNow) {
                const pendingNotes = notes.filter(note => note.fiscalStatus === FiscalDocumentStatus.PENDING)
                for (const note of pendingNotes) {
                    try {
                        await generateCreditNote(note.id)
                    } catch (error) {
                        showErrorStrToast(`La NC #${note.code} quedó pendiente de emitir: ${error instanceof Error ? error.message : 'no se pudo emitir.'}`)
                    }
                }
            }

            // The detail shows what was just saved: the operation, its documents and its notes are read from the db
            const { loadSaleOperation } = saleOperationLoaders()
            await loadSaleOperation(table, operationId, true)
            const { loadOperationFiscalDocuments } = fiscalDocumentLoaders()
            await loadOperationFiscalDocuments(operationId, false)
            const { loadOperationAdjustmentNotes } = adjustmentNoteLoaders()
            await loadOperationAdjustmentNotes(operationId, false)

            Emitter.emit(Event.DB_SUBMIT_DONE, true)
        } catch (error) {
            closeModal(ModalId.SPINNER)
            showErrorStrToast(error instanceof Error ? error.message : 'No se pudo generar la nota de crédito.')
        }
    }

    return {
        submitCreditNote
    }
}
